import { render, staticRenderFns } from "./select-lab-product.vue?vue&type=template&id=7d67978c"
import script from "./select-lab-product.vue?vue&type=script&lang=js"
export * from "./select-lab-product.vue?vue&type=script&lang=js"
import style0 from "./select-lab-product.vue?vue&type=style&index=0&id=7d67978c&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports